'use client';

import { useRouter } from '@bprogress/next/app';
import { useSelector } from '@xstate/store/react';
import { useTranslations } from 'next-intl';

import { CategoryTree } from '@/fo/api/magento';
import { FeatureProductTileBase } from '@/fo/feature/product/tile/base';
import {
  selectProducts,
  selectCategories,
  storeSearchSuggestion,
  searchActions
} from '@/fo/store/search-suggestion';
import { MappedProduct } from '@/fo/util/map-product-data';

import { InputSearch } from '../components/InputSearch/InputSearch';
import { SuggestionGroup } from '../components/SuggestionGroup/SuggestionGroup';

import { styles } from './FeatureSearchSuggestionBase.styles';
export interface FeatureSearchSuggestionBaseProps {
  isAuthorized?: boolean;
  defaultSearchData?: {
    defaultTop: {
      text: string;
      url?: string;
    }[];
    defaultCategories: CategoryTree[];
  };
  defaultProducts?: MappedProduct[];
}

export function FeatureSearchSuggestionBase({
  isAuthorized = false,
  defaultSearchData,
  defaultProducts
}: FeatureSearchSuggestionBaseProps) {
  const t = useTranslations();
  const slots = styles();
  const router = useRouter();
  const products = useSelector(storeSearchSuggestion, selectProducts);
  const categories = useSelector(storeSearchSuggestion, selectCategories);
  const { defaultTop = [], defaultCategories = [] } = defaultSearchData ?? {};
  const handleSearch = (query: string) => {
    router.push(`/search?q=${query}`);
  };

  if (!products) {
    searchActions.setDefaultData({
      products: defaultProducts ?? [],
      categories: defaultCategories
    });
  }

  const onProductClick = (
    e: React.MouseEvent<HTMLDivElement>,
    product: MappedProduct
  ) => {
    e.stopPropagation();
    // какая-то проблема с переходом, добавил явную обертку
    router.push(product.link);
  };

  return (
    <div className={slots.base()}>
      <div className={slots.suggestions()}>
        <InputSearch onSearch={handleSearch} />

        <div className={slots.content()}>
          <div className={slots.categories()}>
            <SuggestionGroup
              title={t('Frequently searched for')}
              items={defaultTop.map((item: { text: string; url?: string }) => ({
                text: item.text,
                url: item.url
              }))}
            />

            <SuggestionGroup
              title={t('Categories')}
              items={(categories.length > 0
                ? categories
                : defaultCategories || []
              ).map((item) => ({
                text: item.name ?? '',
                url: item.url_path ? `/catalog/${item.url_path}` : undefined
              }))}
            />
          </div>
          <div className={slots.products()}>
            <div className={slots.productList()}>
              {(products.length > 0 ? products : defaultProducts || []).map(
                (product, index) => (
                  <div
                    key={`${product.sku}-${index}`}
                    className={slots.productItem()}
                    onClick={(e) => {
                      onProductClick?.(e, product);
                    }}
                  >
                    <FeatureProductTileBase
                      isAuthorized={isAuthorized}
                      data={product}
                      type="search"
                      listName="list-result-search"
                      positionIndex={index}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
